import { FileType } from "tessa/files";

// Типы файлов
export class CdFileTypes {
  public static DefaultFileType: FileType = new FileType('ab387c69-fd62-0655-bbc3-b879e433a143', '$CardTypes_TypesNames_File');
  public static VirtualAdded: FileType = new FileType('ab387c69-fd62-0655-bbc3-b879e433a143', 'VirtualAddedFile');
  static EnhanceSignType = 'EnhanceSign';
  static GetInWorkStampType = 'GetInWorkStamp';
  static GetCSVReportType = 'GetCSVReport';
  static GetFileForPrintType = 'GetFileForPrint';
  static GetCompiledPdfType = "GetCompiledPdf";
  static GetZipArchiveType = "GetZipArchive";
  static GetExecutiveDocumentationRegistryFile = "GetExecutiveDocumentationRegistryFile";//  Файл "Реестр ИД". TES-7477 
  static GetZipArchiveWithoutDirectoriesType = "GetZipArchiveWithoutDirectories";
}